import { render, staticRenderFns } from "./TabByDays.vue?vue&type=template&id=6bf2e710&"
import script from "./TabByDays.vue?vue&type=script&lang=ts&"
export * from "./TabByDays.vue?vue&type=script&lang=ts&"
import style0 from "./TabByDays.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
